// Nav footer

function closeAllMenusExcept(currentMenu) {
  const allMenus = document.querySelectorAll(".el-active");
  for (let i = 0; i < allMenus.length; i++) {
    if (
      allMenus[i] !== currentMenu &&
      allMenus[i].classList.contains("active")
    ) {
      const links = allMenus[i].nextElementSibling;
      const b = allMenus[i].querySelector("b");
      allMenus[i].classList.remove("active");
      b.style.transform = "";
      links.style.overflow = "hidden";
      links.style.height = "0";
    }
  }
}

function toggleNav() {
  closeAllMenusExcept(this);

  const links = this.nextElementSibling;
  const b = this.querySelector("b");

  if (this.classList.contains("active")) {
    this.classList.remove("active");
    b.style.transform = "";
    links.style.overflow = "hidden";
    links.style.height = "0";
  } else {
    this.classList.add("active");
    b.style.transform = "rotate(180deg)";
    links.style.overflow = "unset";
    links.style.height = "auto";
  }
}

function toggleNavDestinoMenu() {
  closeAllMenusExcept(this);

  const links = this.nextElementSibling;
  const b = this.querySelector("b");

  if (this.classList.contains("active")) {
    this.classList.remove("active");
    b.style.transform = "";
    links.style.overflow = "hidden";
    links.style.height = "0";
  } else {
    this.classList.add("active");
    b.style.transform = "rotate(180deg)";
    links.style.overflow = "unset";
    links.style.height = "auto";
  }
}

const elActive = document.querySelectorAll(".el-active");
const destinoMenuActive = document.querySelectorAll(".destino-menu .el-active");

function addClickListeners() {
  for (let i = 0; i < elActive.length; i++) {
    elActive[i].addEventListener("click", toggleNav);
  }

  for (let i = 0; i < destinoMenuActive.length; i++) {
    destinoMenuActive[i].addEventListener("click", toggleNavDestinoMenu);
  }
}

function removeClickListeners() {
  for (let i = 0; i < elActive.length; i++) {
    elActive[i].removeEventListener("click", toggleNav);
  }

  for (let i = 0; i < destinoMenuActive.length; i++) {
    destinoMenuActive[i].removeEventListener("click", toggleNavDestinoMenu);
  }
}

// Sem necessidade de verificar o tamanho da janela
addClickListeners();



// WEBPACK FOOTER //
// ./scripts/routes/footer.js